export var MediaQueries;
(function (MediaQueries) {
    MediaQueries["X_SMALL"] = "(min-width: 320px)";
    MediaQueries["SMALL"] = "(min-width: 480px)";
    MediaQueries["MEDIUM"] = "(min-width: 640px)";
    MediaQueries["LARGE"] = "(min-width: 1024px)";
    MediaQueries["X_LARGE"] = "(min-width: 1170px)";
    MediaQueries["XX_LARGE"] = "(min-width: 1440px)";
})(MediaQueries || (MediaQueries = {}));
//# sourceMappingURL=mediaQueries.js.map